import React from 'react'
import { X } from 'lucide-react'
import { parseMentions } from '@/lib/mentions'

// A row of pills — one per teammate @-mentioned in the current draft — giving the
// composer visual confirmation of who'll be notified (the raw @[Name](id) token stays
// in the textarea as source syntax). The ✕ removes that person's token from the draft.
// Shared by the team-chat + inbox-note composers. Renders nothing when no mentions.
export default function DraftMentionPills({
  content, onRemove, style,
}: {
  content: string
  onRemove: (userId: string) => void
  style?: React.CSSProperties
}) {
  const mentions = parseMentions(content)
  if (!mentions.length) return null
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, ...style }}>
      {mentions.map(m => (
        <span key={m.userId} style={{ display: 'inline-flex', alignItems: 'center', gap: 4, color: 'var(--accent-text)', background: 'var(--accent-dim)', borderRadius: 6, padding: '2px 4px 2px 7px', fontSize: 12, fontWeight: 600 }}>
          @{m.name}
          <button type="button" onClick={() => onRemove(m.userId)} aria-label={`Remove ${m.name}`}
            style={{ display: 'flex', alignItems: 'center', background: 'none', border: 'none', cursor: 'pointer', color: 'var(--accent-text)', padding: 0, opacity: 0.7 }}>
            <X style={{ width: 12, height: 12 }} />
          </button>
        </span>
      ))}
    </div>
  )
}
